import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiQRCodeViewComponent } from './qr-code-view.component';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '../app-text';
import { MatIconModule } from '@angular/material/icon';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
    imports: [CommonModule, MatButtonModule, FiAppTextSharedModule, MatIconModule, QRCodeComponent],
    declarations: [FiQRCodeViewComponent],
    exports: [FiQRCodeViewComponent],
})
export class FiQRCodeViewModule {}
